import { ReactNode } from 'react'
import { Permission } from 'extra/types/Permissions'
import { useAuth } from '../context/AuthContext'

interface RequirePermissionProps {
  permission: Permission
  fallback?: ReactNode
  children: ReactNode
}

export function RequirePermission ({ permission, fallback = null, children }: RequirePermissionProps) {
  const { hasPermission, authLoading } = useAuth()

  if (authLoading) {
    return null
  }

  if (!hasPermission(permission)) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
